(() => {
  const initialized = new WeakSet();

  function initCountdown(root) {
    const countdown = root.querySelector('[data-vena-listicle-countdown]');
    if (!countdown || countdown.dataset.initialized === 'true') return;
    countdown.dataset.initialized = 'true';

    const durationSeconds = Number.parseInt(countdown.dataset.countdownSeconds, 10) || 42478;
    const storageKey = `vena-listicle-countdown-end:${root.id}`;
    let endTime = 0;

    try {
      endTime = Number.parseInt(window.localStorage.getItem(storageKey), 10) || 0;
      if (!endTime) {
        endTime = Date.now() + (durationSeconds * 1000);
        window.localStorage.setItem(storageKey, String(endTime));
      }
    } catch (error) {
      endTime = Date.now() + (durationSeconds * 1000);
    }

    function renderCountdown() {
      const remaining = Math.max(0, endTime - Date.now());
      const totalSeconds = Math.ceil(remaining / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const hoursNode = countdown.querySelector('[data-vena-countdown-hours]');
      const minutesNode = countdown.querySelector('[data-vena-countdown-minutes]');
      const secondsNode = countdown.querySelector('[data-vena-countdown-seconds]');
      if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
      if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
      if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');

      if (remaining <= 0) window.clearInterval(countdown.timer);
    }

    renderCountdown();
    countdown.timer = window.setInterval(renderCountdown, 1000);
  }

  function init(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    document.body.classList.add('vena-listicle-active');
    initCountdown(root);

    const trigger = root.querySelector('[data-vena-listicle-trigger]');
    const sticky = root.querySelector('[data-vena-listicle-sticky]');
    const buyBoxes = [...root.querySelectorAll('[data-vena-listicle-buybox]')];
    if (!trigger || !sticky || !('IntersectionObserver' in window)) return;

    let hasPassedFirstReason = false;
    const visibleBuyBoxes = new Set();

    function setStickyVisible(visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function updateSticky() {
      setStickyVisible(hasPassedFirstReason && visibleBuyBoxes.size === 0);
    }

    const reasonObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        hasPassedFirstReason = entry.boundingClientRect.bottom < 0;
        updateSticky();
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px 0px 0px'
    });

    reasonObserver.observe(trigger);

    if (buyBoxes.length) {
      const buyBoxObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleBuyBoxes.add(entry.target);
          } else {
            visibleBuyBoxes.delete(entry.target);
          }
        });
        updateSticky();
      }, {
        threshold: 0.16,
        rootMargin: '-14% 0px -14% 0px'
      });

      buyBoxes.forEach((buyBox) => buyBoxObserver.observe(buyBox));
    }
  }

  function initAll(scope = document) {
    const roots = [];
    if (scope.matches?.('[data-vena-ad-listicle]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-vena-ad-listicle]'));
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();